const Settings = {
    SlotDuration: 30 * 60 * 1000,
    DateUnitCount: 7,
};
export default Settings;
  